import { render, staticRenderFns } from "./FooterSystemicoComponent.vue?vue&type=template&id=6a9c58ba&scoped=true"
import script from "./FooterSystemicoComponent.vue?vue&type=script&lang=js"
export * from "./FooterSystemicoComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterSystemicoComponent.vue?vue&type=style&index=0&id=6a9c58ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c58ba",
  null
  
)

export default component.exports